/*
Copyright (c) 2015, salesforce.com, inc. All rights reserved.
Copyright (c) 2017, Picsa Advisory Services (Pty) Ltd. All rights reserved.

Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
Neither the name of salesforce.com, inc. nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.

THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES LOSS OF USE, DATA, OR PROFITS OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
*/

import React from 'react'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router-dom'

import {
  TabbedView
} from '../'

export class PageNavigation extends React.PureComponent {
  static propTypes = {
    items: PropTypes.arrayOf(PropTypes.shape({
      link: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      hide: PropTypes.bool,
      onClick: PropTypes.func
    })).isRequired,
    currentItem: PropTypes.number,
    className: PropTypes.string
  }

  constructor(props) {
    super(props)

    this.state = {
      activeTab: props.currentItem,
      overflowIndex: props.items.length,
      showOverflowMenuItems: false
    }

    this.listRef = React.createRef()
    this.overflowMenuRef = React.createRef()
  }

  // NOTE: code segments for handling menu item overflow is commented out until need for use arises
  // componentDidMount() {
  //   this.setOverflowIndex()
  // }

  componentDidUpdate() {
    // this.setOverflowIndex()
    if (this.state.overflowIndex !== this.props.items.length) {
      document.addEventListener("click", this.listenForClickOutside)  // only add click event listener if overflow menu show as page nav option
    }
  }

  componentWillUnmount() {
    if (this.state.overflowIndex !== this.props.items.length) {
      document.removeEventListener("click", this.listenForClickOutside)
    }
  }

  listenForClickOutside = (e) => {
    if (this.overflowMenuRef.current.contains(e.target)) {
      // click is inside, stay open
      return
    }

    // click outside
    this.setState({ showOverflowMenuItems: false })
  }

  setOverflowIndex = () => {
    if (this.itemsOverflowsWidth()) {
      this.setState(prevState => ({ overflowIndex: prevState.overflowIndex - 1 }))
    }
  }

  itemsOverflowsWidth = () => (
    this.listRef.current.clientHeight > 60
  )

  render() {
    let items = this.props.items.slice(0, this.state.overflowIndex)
    // let overflowItems = this.state.overflowIndex < this.props.items.length
    //   ? this.props.items.slice(this.state.overflowIndex)
    //   : []

    let tabs = items.map(item => item.name)
    return (
      <div className='u-bg-color-white slds-p-top_x-small'>
        <TabbedView
          tabs={tabs}
          contents={[]}
          selectedTab={this.state.activeTab}
          onClick={tabIndex => {
            let item = items[tabIndex]
            this.props.history.push(item.link)
            this.setState({ activeTab: tabIndex })
            if (item.onClick) {
              item.onClick()
            }
          }}
          tabsClassName='slds-align_absolute-center'
        />
      </div>
    )
  }
}

export default withRouter(PageNavigation)



// WEBPACK FOOTER //
// ./src/components/page-navigation/index.js